import App from './App';

window.App = App;

App.initialize();



// WEBPACK FOOTER //
// ./scripts/main.js